import React, { useState, useEffect} from 'react';
import { motion,} from 'framer-motion';


const ScrollProgressBar = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / totalHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="fixed right-4 sm:right-6 top-1/2 -translate-y-1/2 h-[60%] w-1 bg-white/5 rounded-full z-40 hidden sm:block">
      <motion.div
        className="w-full bg-gradient-to-b from-mint-400 to-indigo-400 rounded-full"
        style={{ height: `${scrollProgress}%` }}
        initial={{ height: 0 }}
        animate={{ height: `${scrollProgress}%` }}
        transition={{ duration: 0.1 }}
      />
    </div>
  );
};
export default ScrollProgressBar